import { Plus, Trash2, Check } from "lucide-react";

function ProposalItem({ proposal, idx, insurers, isSelected, onUpdate, onRemove, onSelect }) {
  var borderCls = isSelected ? "border-emerald-300 bg-emerald-50/50" : "border-gray-200";
  var selBtnCls = isSelected ? "bg-emerald-500 text-white" : "bg-gray-100 text-gray-400 hover:text-emerald-500";

  return (
    <div className={"p-3 border rounded-lg " + borderCls}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-gray-500">Proposta {idx + 1}</span>
        <div className="flex gap-1">
          <button type="button" onClick={function() { onSelect(idx); }} className={"p-1 rounded " + selBtnCls} title="Selecionar" data-testid={"select-proposal-" + idx}><Check className="w-3.5 h-3.5" /></button>
          <button type="button" onClick={function() { onRemove(idx); }} className="p-1 rounded bg-gray-100 text-gray-400 hover:text-red-500" data-testid={"remove-proposal-" + idx}><Trash2 className="w-3.5 h-3.5" /></button>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <select value={proposal.insurer_id || ""} onChange={function(e) { onUpdate(idx, "insurer_id", e.target.value); }} className="px-2 py-1.5 border rounded text-xs" data-testid={"proposal-insurer-" + idx}>
          <option value="">Seguradora...</option>
          {insurers.map(function(ins) { return <option key={ins.id} value={ins.id}>{ins.name}</option>; })}
        </select>
        <input type="number" step="0.01" placeholder="Premio (R$)" value={proposal.premium || ""} onChange={function(e) { onUpdate(idx, "premium", parseFloat(e.target.value) || 0); }} className="px-2 py-1.5 border rounded text-xs" data-testid={"proposal-premium-" + idx} />
        <input type="number" step="0.01" placeholder="Franquia (R$)" value={proposal.deductible || ""} onChange={function(e) { onUpdate(idx, "deductible", parseFloat(e.target.value) || 0); }} className="px-2 py-1.5 border rounded text-xs" />
        <input placeholder="Cobertura" value={proposal.coverage || ""} onChange={function(e) { onUpdate(idx, "coverage", e.target.value); }} className="px-2 py-1.5 border rounded text-xs" />
      </div>
    </div>
  );
}

export default function ProposalEditor({ proposals, selectedIndex, insurers, onChange, onSelectIndex }) {
  function addProposal() {
    var p = proposals.slice();
    p.push({ insurer_id: "", insurer_name: "", premium: 0, deductible: 0, coverage: "", notes: "" });
    onChange(p);
  }

  function updateProposal(idx, field, value) {
    var p = proposals.slice();
    var item = {};
    for (var k in p[idx]) item[k] = p[idx][k];
    item[field] = value;
    if (field === "insurer_id") {
      var ins = insurers.find(function(i) { return i.id === value; });
      item.insurer_name = ins ? ins.name : "";
    }
    p[idx] = item;
    onChange(p);
  }

  function removeProposal(idx) {
    var p = proposals.filter(function(_, i) { return i !== idx; });
    onChange(p);
    if (selectedIndex === idx) onSelectIndex(null);
    else if (selectedIndex > idx) onSelectIndex(selectedIndex - 1);
  }

  return (
    <div className="border-t pt-4">
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-sm font-semibold text-[#0A2F3D]">Propostas de Seguradoras</h4>
        <button type="button" onClick={addProposal} className="flex items-center gap-1 text-xs text-[#3B82F6] font-medium hover:underline" data-testid="add-proposal-btn"><Plus className="w-3.5 h-3.5" />Adicionar</button>
      </div>
      {proposals.length === 0 && <p className="text-xs text-gray-400 text-center py-4">Nenhuma proposta adicionada</p>}
      <div className="space-y-3">
        {proposals.map(function(prop, idx) {
          return <ProposalItem key={idx} proposal={prop} idx={idx} insurers={insurers} isSelected={selectedIndex === idx} onUpdate={updateProposal} onRemove={removeProposal} onSelect={onSelectIndex} />;
        })}
      </div>
    </div>
  );
}
